import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useUnmountedRef } from 'ahooks';
import SlideRuler from 'slide-ruler';
import { throttle } from 'lodash-es';

import cx from './index.module.scss';

interface Props {
  isShow: boolean;
  min: number;
  max: number;
  value: number;
  defaultValue: number;
  onChange: (value: number) => void;
}

export const MySlideRuler: React.FC<Props> = ({ isShow, value, defaultValue, onChange, min, max }) => {
  const slideRulerRef = useRef(null);
  const [controlIsShow, setControlIsShow] = useState(true);
  const isUnmount = useUnmountedRef();

  const handleValueChange = useMemo(
    () =>
      throttle(value => {
        if (!isUnmount.current) {
          onChange(value);
        }
      }, 80),
    [isUnmount, onChange]
  );

  useEffect(() => {
    if (!isShow) return;

    /** slider-ruler组件无法受控，通过重新渲染的方式来动态更改值 */
    setControlIsShow(false);
    setTimeout(() => {
      setControlIsShow(true);
      setTimeout(() => {
        new SlideRuler({
          el: slideRulerRef.current,
          handleValue: handleValueChange,
          currentValue: value || defaultValue,
          precision: 0.1,
          fontSize: 18,
          canvasWidth: 456,
          canvasHeight: 120,
          fontColor: '#55568E',
          heightDecimal: 50,
          heightDigit: 20,
          colorDecimal: '#6B6C97',
          colorDigit: '#6B6C974D',
          divide: 8,
          fontMarginTop: 70,
          minValue: min,
          maxValue: max,
        });
      }, 50);
    }, 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow, value, defaultValue]);

  return (
    <div className={cx('SlideRuler')}>
      <div className={cx('current-value-indicator')} />
      {controlIsShow && <div ref={slideRulerRef} className={cx('slide-ruler-wrapper')} />}
    </div>
  );
};
